import api from '../../ApiConfig';
import { Apis } from '../../config';

import { Alerts } from '../index'

const getHomeBanner = async () => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetHomeBanner,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};
const updateHomeBanner = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.UpdateHomeBanner, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};



const exportedObject = {
    getHomeBanner,
    updateHomeBanner
}
export default exportedObject;